// Email validation utility
const VALID_EXTENSIONS = [".co.za", ".com", ".net", ".org", ".edu", ".gov", ".io", ".biz", ".info", ".co", ".za", ".ac.za"];

export function validateEmail(email) {
  if (!email) return { valid: false, error: "Email is required" };
  const trimmed = email.trim();
  if (trimmed !== email || trimmed.includes(" "))
    return { valid: false, error: "Email cannot contain spaces" };
  if (!trimmed.includes("@"))
    return { valid: false, error: "Email must contain an @ symbol" };
  const parts = trimmed.split("@");
  if (parts.length !== 2)
    return { valid: false, error: "Email must contain exactly one @ symbol" };
  const [local, domain] = parts;
  if (!local || !domain)
    return { valid: false, error: "Please enter a valid email address (e.g., name@example.com)" };
  if (/^[^a-zA-Z0-9]/.test(local) || /[^a-zA-Z0-9]$/.test(local))
    return { valid: false, error: "Email cannot start or end with special characters" };
  if (domain.split(".")[0].length < 2)
    return { valid: false, error: "Please enter a valid email address (e.g., name@example.com)" };
  const hasValid = VALID_EXTENSIONS.some((ext) => domain.toLowerCase().endsWith(ext));
  if (!hasValid)
    return { valid: false, error: "Email must end with a valid domain (.com, .co.za, .net, etc.)" };
  return { valid: true, error: null };
}

// SKU validation utility
export function validateSku(sku) {
  if (!sku) return { valid: false, error: "SKU is required" };
  const trimmed = sku.trim();
  if (trimmed.includes(" ")) return { valid: false, error: "SKU cannot contain spaces" };
  if (!/^[A-Za-z0-9\-]+$/.test(trimmed))
    return { valid: false, error: "SKU can only contain letters, numbers, and hyphens" };
  if (trimmed.length > 50) return { valid: false, error: "SKU must be 50 characters or less" };
  return { valid: true, error: null };
}

// CSV parsing utility
export function parseCSV(text) {
  const lines = text.split("\n").filter((l) => l.trim());
  if (lines.length < 2) return { headers: [], rows: [] };
  const headers = parseCSVLine(lines[0]).map((h) => h.trim().toLowerCase().replace(/^"|"$/g, ""));
  const rows = [];
  for (let i = 1; i < lines.length; i++) {
    const values = parseCSVLine(lines[i]);
    const row = {};
    headers.forEach((h, j) => { row[h] = (values[j] || "").replace(/^"|"$/g, "").trim(); });
    rows.push(row);
  }
  return { headers, rows };
}

function parseCSVLine(line) {
  const values = [];
  let current = "";
  let inQuotes = false;
  for (const char of line) {
    if (char === '"') { inQuotes = !inQuotes; }
    else if (char === "," && !inQuotes) { values.push(current); current = ""; }
    else { current += char; }
  }
  values.push(current);
  return values;
}

// CSV template generators
export const CSV_TEMPLATES = {
  suppliers: {
    filename: "suppliers_import_template.csv",
    content: `supplier_code,company_name,contact_person,email,phone,physical_address,payment_terms,tax_number,bank_name,bank_account_number,bank_account_name,status,notes
SUP-001,ABC Supplies Ltd,John Doe,john@abc.co.za,(011) 123-4567,"123 Main St, Johannesburg",30 days,1234567890,Standard Bank,1234567890,ABC Supplies Ltd,Active,Preferred supplier
SUP-002,Best Tools Co,Jane Smith,jane@besttools.com,(021) 555-1234,"456 Park Ave, Cape Town",60 days,9876543210,FNB,9876543210,Best Tools Co,Active,`,
  },
  customers: {
    filename: "customers_import_template.csv",
    content: `customer_code,company_name,contact_person,email,phone,physical_address,delivery_address,payment_terms,tax_number,credit_limit,customer_type,status,notes
CUST-001,XYZ Retailers,Jane Smith,jane@xyz.co.za,(011) 987-6543,"456 Park Ave, Sandton","Same as physical",60 days,9876543210,50000,Wholesale,Active,VIP customer
CUST-002,Quick Shop,Bob Jones,bob@quickshop.com,(031) 111-2222,"789 Beach Rd, Durban","789 Beach Rd, Durban",30 days,1122334455,25000,Retail,Active,`,
  },
  products: {
    filename: "products_import_template.csv",
    content: `sku,product_name,description,category,subcategory,unit_of_measure,length,width,height,dimension_unit,weight,weight_unit,cost_price,selling_price,quantity,reorder_level,supplier_code,status
PUMP-001,Hydraulic Pump 5000,Industrial hydraulic pump 5000 series,Pumps,Hydraulic,Each,150,100,80,cm,25,kg,1500.00,2250.00,50,10,SUP-001,Active
VALVE-001,Ball Valve 2 inch,Brass ball valve 2 inch,Valves,Ball Valves,Each,50,50,100,mm,0.5,kg,85.50,135.00,200,25,SUP-001,Active`,
  },
};

export function downloadTemplate(entityType) {
  const tmpl = CSV_TEMPLATES[entityType];
  if (!tmpl) return;
  const blob = new Blob(["\uFEFF" + tmpl.content], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", tmpl.filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 150);
}
